import { Component } from '@angular/core'
import { CtrlBaseComponent } from '../ctrl-base.component';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ct-preview',
  templateUrl: './ct-preview.component.html',
  styleUrls: ['./ct-preview.component.css']
})


export class CtPreviewComponent extends CtrlBaseComponent {

  src: SafeResourceUrl;
  noSrcMesage: string;
  height: string;

  constructor() {
    super();
  }

  getSrc(): any { return this.src }
  getGViewerSrc(): any { return `https://docs.google.com/gview?url=${this.src}&embedded=true` }
  getHeight(): any { return (this.height + 'px') }
  getNoSrcMessage(): any { return this.noSrcMesage }


  setSrc(src: string): void { this.src = src }
  setHeight(height: string): void { this.height = height }
  setNoSrcMessage(noSrcMesage: string): void { this.noSrcMesage = noSrcMesage }

}

